import lightTheme from "../../../../../libs/theme/src/lib/antd/light.json";
import { ANT_DESIGN_TEXT_SIZE_ENUM } from "../enums/AntDesignEnums";

const typographyTokens = lightTheme.components.Typography;

export const antDesignTextSizeMap: Record<
  ANT_DESIGN_TEXT_SIZE_ENUM,
  { fontSize: number; lineHeight: number }
> = {
  caption: {
    fontSize: typographyTokens.fontSizeCaption,
    lineHeight: typographyTokens.lineHeightCaption
  },
  sm: {
    fontSize: typographyTokens.fontSizeSM,
    lineHeight: typographyTokens.lineHeightSM
  },
  md: {
    fontSize: typographyTokens.fontSize,
    lineHeight: typographyTokens.lineHeight
  },
  lg: {
    fontSize: typographyTokens.fontSizeLG,
    lineHeight: typographyTokens.lineHeightLG
  },
  xl: {
    fontSize: typographyTokens.fontSizeXL,
    lineHeight: typographyTokens.lineHeightXL
  }
};
